import { useTheme } from '@components/theme';
import classNames from 'classnames';
import React, { Dispatch } from 'react';

import styles from './Tabs.module.scss';

export type TABS = 'portfolio' | 'profile' | 'reviews';

interface ITabsProps {
  tabs: string[];
  set: Dispatch<any>;
  selectedTab: string;
}

const Tabs = ({ tabs, set, selectedTab }: ITabsProps) => {
  return (
    <div className={styles.Tabs}>
      {tabs.map((tab) => (
        <Tab
          key={tab}
          set={() => set(tab)}
          isActive={selectedTab === tab}
          text={tab}
        />
      ))}
    </div>
  );
};

function Tab({
  text, set, isActive
}: {
  text: string;
  set: () => void;
  isActive: boolean;
}) {
  const theme = useTheme();

  return (
    <button
      type="button"
      data-test={`tabs-${text}`}
      className={ classNames(
        theme.styles.Overline,
        `${isActive ? styles.Active : ''}`
      )}
      onClick={set}
    >
      {text}
    </button>
  );
}

export default Tabs;
